import React, { useState } from "react";
import HeaderCard from "../../../components/dashboard/card/HeaderCard";
import useWindowDimensions from "../ScreenSize";
import { FaTruck } from "react-icons/fa";
import { IoMdTrain } from "react-icons/io";
import { GiCommercialAirplane } from "react-icons/gi";
import "bootstrap/dist/css/bootstrap.css";
import BarChart from "../../../components/dashboard/charts/BarChart";
import DonutChart from "../../../components/dashboard/charts/DonutChart";
import PieChart from "../../../components/dashboard/charts/PieChart";
import { Card } from "react-bootstrap";
import SpineAreaChart from "../../../components/dashboard/charts/SpineAreaChart";
import LineColumnArea from "../../../components/dashboard/charts/LineColumnArea";
import { CardBody, CardTitle, Col, Row } from "reactstrap";
import "./Client.scss";
import { TfiWrite } from "react-icons/tfi";
import { MdOutlinePendingActions } from "react-icons/md";
import { FcApproval } from "react-icons/fc";
import { ImCross } from "react-icons/im";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import toTitleCase from "../../../lib/titleCase/TitleCase";

const CorrectionRequestDashboard = () => {
  const navigate = useNavigate();
  const page_num = useSelector((state) => state.pagination.page_number);
  const data_len = useSelector((state) => state.pagination.data_length);

  // To get Screen Size
  const { height, width } = useWindowDimensions();

  // FOr Donut Chart
  const series = [20, 30, 30, 10, 10];
  const labels = ["Series 1", "Series 2", "Series 3", "Series 4", "Series 5"];
  const colors = ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"];

  // used for bar chart
  const seriesData = [380, 430, 450, 475, 550, 584, 780, 1100, 1220, 1365, 100];
  const categories = [
    "South Korea",
    "Canada",
    "United Kingdom",
    "Netherlands",
    "Italy",
    "France",
    "Japan",
    "United States",
    "China",
    "Germany",
    "USA",
  ];
  const color = " rgb(136 , 132,216)";

  const Correction_data = [
    {
      id: 1,
      employee_firstname: "Mohit",
      employee_middlename: "Kumar",
      employee_lastname: "Mahato",
      employee_id: "ETC0001",
      reporting_managerfirstname: "Rohit",
      reporting_managermiddlename: "",
      reporting_managerlastname: "kumar",
      correction_type: "Attendance",
      issue_date: "12/01/2000",
    },
    {
      id: 2,
      employee_firstname: "Mohit",
      employee_middlename: "Kumar",
      employee_lastname: "Mahato",
      employee_id: "ETC0001",
      reporting_managerfirstname: "Rohit",
      reporting_managermiddlename: "",
      reporting_managerlastname: "kumar",
      correction_type: "Attendance",
      issue_date: "12/01/2000",
    },
    {
      id: 3,
      employee_firstname: "Mohit",
      employee_middlename: "Kumar",
      employee_lastname: "Mahato",
      employee_id: "ETC0001",
      reporting_managerfirstname: "Rohit",
      reporting_managermiddlename: "",
      reporting_managerlastname: "kumar",
      correction_type: "Attendance",
      issue_date: "12/01/2000",
    },
    {
      id: 3,
      employee_firstname: "Mohit",
      employee_middlename: "Kumar",
      employee_lastname: "Mahato",
      employee_id: "ETC0001",
      reporting_managerfirstname: "Rohit",
      reporting_managermiddlename: "",
      reporting_managerlastname: "kumar",
      correction_type: "Attendance",
      issue_date: "12/01/2000",
    },
    {
      id: 3,
      employee_firstname: "Mohit",
      employee_middlename: "Kumar",
      employee_lastname: "Mahato",
      employee_id: "ETC0001",
      reporting_managerfirstname: "Rohit",
      reporting_managermiddlename: "",
      reporting_managerlastname: "kumar",
      correction_type: "Attendance",
      issue_date: "12/01/2000",
    },
  ];

  //  Spine Area Chart
  const seriesData1 = [
    { data: [30, 40, 35, 50, 49, 60, 70] },
    { data: [20, 35, 40, 60, 58, 70, 80] },
  ];

  const optionsData = {
    stroke: { curve: "smooth", width: 3 },
    colors: ["#556ee6", "#34c38f"],
    tooltip: { x: { format: "dd/MM/yy HH:mm" } },
  };

  let list1 = ["1", "2", "3", "4", "5", "6"];

  return (
    <>
      {/* For HeaderCard */}

      <Row style={{ display: "flex" }}>
        <Col>
          <Card
            className="mini-stats-wid hover-card-correction"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              backgroundColor: "#80C4E9",
              maxHeight: "120px",
              minHeight: "120px",
            }}
          >
            <CardBody>
              <div className="d-flex flex-wrap">
                <div className="me-1">
                  <h5
                    className
                    style={{
                      color: "white",
                      fontFamily: "sans-serif",
                      fontSize: "21px",
                    }}
                  >
                    <span>
                      <TfiWrite />
                    </span>{" "}
                    Generated
                  </h5>
                </div>

                <div className="avatar-sm ms-auto center-text-cor">9879879</div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card
            className="mini-stats-wid hover-card-correction"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              maxHeight: "120px",
              minHeight: "120px",
              backgroundColor: "#FFF4B5",
            }}
          >
            <CardBody>
              <div className="d-flex flex-wrap">
                <div className="me-1">
                  <h5
                    className
                    style={{
                      color: "white",
                      fontFamily: "sans-serif",
                      fontSize: "21px",
                    }}
                  >
                    <span>
                      <MdOutlinePendingActions />
                    </span>{" "}
                    Pending
                  </h5>
                </div>

                <div className="avatar-sm ms-auto center-text-cor">9879879</div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card
            className="mini-stats-wid hover-card-correction"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              backgroundColor: "#54B435",
              maxHeight: "120px",
              minHeight: "120px",
            }}
          >
            <CardBody>
              <div className="d-flex flex-wrap">
                <div className="me-1">
                  <h5
                    className
                    style={{
                      color: "white",
                      fontFamily: "sans-serif",
                      fontSize: "21px",
                    }}
                  >
                    <span>
                      <FcApproval color="white" />
                    </span>{" "}
                    Approved
                  </h5>
                </div>

                <div className="avatar-sm ms-auto center-text-cor">9879879</div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card
            className="mini-stats-wid hover-card-correction"
            style={{
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              backgroundColor: "#F95454",
              maxHeight: "120px",
              minHeight: "120px",
            }}
          >
            <CardBody>
              <div className="d-flex flex-wrap">
                <div className="me-1">
                  <h5
                    className
                    style={{
                      color: "white",
                      fontFamily: "sans-serif",
                      fontSize: "21px",
                    }}
                  >
                    <span>
                      <ImCross />
                    </span>{" "}
                    Rejected
                  </h5>
                </div>

                <div className="avatar-sm ms-auto center-text-cor">9879879</div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <div className="wrapper-cards-cor">
        <div
          style={{
            textAlign: "center",
            fontSize: "22px",
            fontFamily: "Georgia",
            display: "flex",
            postion: "relative",
            padding: "inherit",
            marginBottom: "6px",
          }}
        >
          Last Five Correction Request
        </div>
      </div>

      {/* For table */}
      <div>
        <div className="second-off">
          <table className="table_correction" style={{ width: "100%" }}>
            <tr className="table_ctd">
              <td>S.N.</td>
              <td>Employee Name</td>
              <td>Employee Id</td>
              <td>Reporting Manager</td>
              <td>Correction Type</td>
              <td>Isuue Date</td>
            </tr>

            {Correction_data?.map((value, index) => {
              return (
                <>
                  <tr>
                    <td style={{ color: "black" }}>
                      {page_num == 1
                        ? index + 1
                        : index + 1 + data_len * (page_num - 1)}
                    </td>
                    <td style={{ color: "black" }}>
                      {value?.employee_firstname
                        ? toTitleCase(value?.employee_firstname || "") +
                          " " +
                          toTitleCase(value?.employee_middlename || "") +
                          " " +
                          toTitleCase(value?.employee_lastname || "")
                        : "-"}
                    </td>
                    <td style={{ color: "black" }}>{value?.employee_id}</td>
                    <td style={{ color: "black" }}>
                      {value?.reporting_managerfirstname
                        ? toTitleCase(value?.reporting_managerfirstname || "") +
                          " " +
                          toTitleCase(
                            value?.reporting_managermiddlename || ""
                          ) +
                          " " +
                          toTitleCase(value?.reporting_managerlastname || "")
                        : "-"}
                    </td>
                    <td style={{ color: "black" }}>{value?.correction_type}</td>
                    <td style={{ color: "black" }}>{value?.issue_date}</td>
                  </tr>
                </>
              );
            })}
          </table>
        </div>
      </div>

      {/* for Charts */}

      {/*Line ColumnArea Chart */}

      <Row style={{marginTop: "0" }}>
        <Col lg={12}>
          <Card>
            <CardBody
              style={{padding: "0", margin: "0" }}
            >
              <div
                style={{
                  textAlign: "center",
                  fontSize: "22px",
                  fontFamily: "Georgia",
                  display: "flex",
                  postion: "relative",
                  padding: "inherit",
                  marginBottom: "6px",
                  marginTop: 0,
                }}
              >
                Claims Request
              </div>
              <Row className="justify-content-center">
                <Col sm={6} lg={3} xs={12} md={6}>
                  <div className="text-center hover-card-claim tw-mb-3">
                    <h5 className="mb-0 font-size-20">2541</h5>
                    <p className="text-muted">
                      <span style={{ display: "block" }}>
                        Total Claims Request
                      </span>
                      <span style={{ display: "block" }}> </span>
                    </p>
                  </div>
                </Col>
                <Col sm={6} lg={3} xs={12} md={6}>
                  <div className="text-center hover-card-claim">
                    <h5 className="mb-0 font-size-20">102030</h5>
                    <p className="text-muted">Approved Claims Request</p>
                  </div>
                </Col>
                <Col sm={6} lg={3} xs={12} md={6}>
                  <div className="text-center hover-card-claim">
                    <h5 className="mb-0 font-size-20">86541</h5>
                    <p className="text-muted">Pending Claims Request</p>
                  </div>
                </Col>
                <Col sm={6} lg={3} xs={12} md={6}>
                  <div className="text-center hover-card-claim">
                    <h5 className="mb-0 font-size-20">86541</h5>
                    <p className="text-muted">Rejected Claims Request</p>
                  </div>
                </Col>
              </Row>
              <div className="tw-mt-3 stylecard-cor">
                <LineColumnArea />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Pie Chart */}

      {/* Horizontal Chart */}

      {/* Vertical Chart */}

      {/* Spine Area Chart */}
    </>
  );
};

export default CorrectionRequestDashboard;
